import React from "react";
import { PostCard } from "./PostCard";

export function FeaturedPosts({ posts }) {
  return (
    <div className="flex flex-col xl:flex-row xl:flex-wrap gap-4">
      {posts?.map((post) => (
        <PostCard key={post.id} post={post} titleClickable />
      ))}
    </div>
  );
}
